export default {
  avatar: {
    error: '图片上传失败，请您重新上传！',
  }
}